import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import DrawerWithAutoWidth from '../../../components/DrawerWithAutoWidth';
import UserGroupAddUserForm from './UserGroupAddUserForm';

export type UserGroupAddUserDrawerProps = {
    userGroup: UserGroupSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const UserGroupAddUserDrawer = ({ userGroup, onClose, visible }: UserGroupAddUserDrawerProps) => {
    const { t } = useTranslation(['userGroupDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('userGroupDetails:userDrawer.cancelButton')}</Button>
                    <Button form="addUsers" htmlType="submit" type="primary">
                        {t('userGroupDetails:userDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('userGroupDetails:userDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <UserGroupAddUserForm onComplete={onClose} userGroup={userGroup} />
        </DrawerWithAutoWidth>
    );
};

export default UserGroupAddUserDrawer;

export const useAddUserDrawer = (userGroup: UserGroupAddUserDrawerProps['userGroup']) => {
    const [visible, setVisible] = useState(false);
    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UserGroupAddUserDrawer onClose={actions.close} userGroup={userGroup} visible={visible} />,
    };
};
